import React from 'react';
import html2canvas from 'html2canvas';
import { createRoot } from 'react-dom/client';

/**
 * React コンポーネントのスクリーンショットを取得
 * @param Component - スクリーンショット対象の React コンポーネント
 * @returns スクリーンショットの Base64 データ
 */
export const captureScreenshot = async (Component: React.FC): Promise<string | null> => {
    const container = document.createElement('div');
    container.style.opacity = '0'; // 完全に透明
    document.body.appendChild(container);

    const captureRef = React.createRef<HTMLDivElement>();
    const root = createRoot(container);

    // コンポーネントを一時的にレンダリング
    root.render(
        <div ref={captureRef}>
            <Component />
        </div>
    );

    // レンダリング完了を待機
    await new Promise((resolve) => setTimeout(resolve, 100));

    // スクリーンショットを取得
    if (captureRef.current) {
        const canvas = await html2canvas(captureRef.current);
        const screenshot = canvas.toDataURL('image/png');

        // 一時的な DOM をクリーンアップ
        root.unmount();
        document.body.removeChild(container);

        return screenshot;
    } else {
        console.error('Capture reference is null');
        root.unmount();
        document.body.removeChild(container);
        return null;
    }
};
